export const TabbarItemsConstants = {
	PROFILES: 'Анкеты',
	MAP: 'Карта',
	NOTIFICATIONS: 'Уведомления',
	PROFILE: 'Профиль',
}
